import React from 'react';
import { Box, Typography } from '@mui/material';
import { InboxOutlined } from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import { colors, radii } from '../../styles/tokens';

export interface EmptyStateProps {
  title: string;
  description?: string;
  instruction?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  align?: 'left' | 'center';
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  instruction,
  icon,
  action,
  align = 'center',
}) => {
  const isCenter = align === 'center';

  return (
    <Box
      sx={{
        py: 4,
        px: 3,
        bgcolor: alpha(colors.primary, 0.03),
        border: `1px solid ${colors.border}`,
        borderRadius: `${radii.card}px`,
        textAlign: isCenter ? 'center' : 'left',
        display: 'flex',
        flexDirection: 'column',
        alignItems: isCenter ? 'center' : 'flex-start',
        gap: 1.5,
      }}
    >
      <Box
        sx={{
          color: colors.textSecondary,
          display: 'flex',
          alignItems: 'center',
          justifyContent: isCenter ? 'center' : 'flex-start',
        }}
      >
        {icon ?? <InboxOutlined sx={{ fontSize: 40, opacity: 0.6 }} />}
      </Box>
      <Typography
        variant="subtitle1"
        component="p"
        sx={{ fontWeight: 700, color: colors.textPrimary }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          variant="body2"
          sx={{
            color: colors.textSecondary,
            lineHeight: 1.6,
            maxWidth: isCenter ? 400 : 'none',
          }}
        >
          {description}
        </Typography>
      )}
      {instruction && (
        <Typography
          variant="caption"
          sx={{
            color: colors.textMuted,
            fontWeight: 500,
            maxWidth: isCenter ? 400 : 'none',
          }}
        >
          {instruction}
        </Typography>
      )}
      {action && <Box sx={{ mt: 0.5 }}>{action}</Box>}
    </Box>
  );
};
